module["exports"] = [
  "شورولت",
  "کادیلاک",
  "فورد",
  "کرایسلر",
  "دوج",
  "جیپ",
  "تسلا",
  "تویوتا",
  "هوندا",
  "نیسان",
  "آٔ‌ئودی",
  "مرسدس بنز",
  "بی ام و",
  "ولکس واگن",
  "پورشه",
  "جگوار",
  "استون مارتین",
  "لندرور",
  "بنتلی",
  "مینی",
  "رولز رویس",
  "فیات",
  "لامبورگینی",
  "مازراتی",
  "فراری",
  "بوگاتی",
  "کیا",
  "هیوندای"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/vehicle/manufacturer.js
// module id = 2914
// module chunks = 1609